import { Navigate, useLocation } from 'react-router-dom'
import { useEffect } from 'react'
import { getAppSettings, updateLastSection, type AppSection } from '../utils/appSettings'

/**
 * Renders at "/" and redirects based on stored lastSection and repo state:
 * - /databases if lastSection is 'databases'
 * - /projects otherwise
 */
export function HomeRedirect() {
  const { lastSection } = getAppSettings()

  if (lastSection === 'databases') {
    return <Navigate to="/databases" replace />
  }

  return <Navigate to="/projects" replace />
}

/**
 * Syncs current pathname to app settings so we know if user is in projects or databases.
 * Renders nothing; run once inside Router.
 */
export function LocationSettingsSync() {
  const { pathname } = useLocation()

  useEffect(() => {
    const section: AppSection | null =
      pathname.startsWith('/projects') || pathname.startsWith('/project') || pathname.startsWith('/repository') || pathname.startsWith('/onboarding')
        ? 'projects'
        : pathname.startsWith('/databases') || pathname.startsWith('/database')
          ? 'databases'
          : null
    if (section) {
      updateLastSection(section)
    }
  }, [pathname])

  return null
}
